import createReducer from '../../utils/createReducer';

import {
  PLAID_LINK_TOKEN_ERROR,
  PLAID_LINK_TOKEN_SUCCESS,
} from '../../actions/plaid/PlaidActionConstants';

const initialState = {
  linkToken: '',
  error: '',
};

export default createReducer(
  {
    [PLAID_LINK_TOKEN_SUCCESS]: getLinkToken,
    [PLAID_LINK_TOKEN_ERROR]: getLinkTokenError,
  },
  initialState,
);

function getLinkToken(state, { payload }) {
  return {
    ...state,
    linkToken: payload,
  };
}

function getLinkTokenError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}
